"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRecommended;
const MAX_RECOMMENDED_CURRENCIES = 4;
function getRecommended(countryCurrency, languageCurrency, mostUsed, available) {
  const candidates = new Set([countryCurrency, languageCurrency, ...mostUsed].filter(c => c != null && c in available).map(c => available[c]));
  return Array.from(candidates).slice(0, MAX_RECOMMENDED_CURRENCIES);
}